import { render, staticRenderFns } from "./ManageSheetPage.vue?vue&type=template&id=456fe66a"
import script from "./ManageSheetPage.vue?vue&type=script&lang=js"
export * from "./ManageSheetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('456fe66a')) {
      api.createRecord('456fe66a', component.options)
    } else {
      api.reload('456fe66a', component.options)
    }
    module.hot.accept("./ManageSheetPage.vue?vue&type=template&id=456fe66a", function () {
      api.rerender('456fe66a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/manage-sheet-page/ManageSheetPage.vue"
export default component.exports